/**
 * Entry CDN IIFE — `window.MjlMyApps`.
 * CSS sudah di dalam bundle; host hanya load script ini (tanpa file .css).
 */
import {
  bus,
  clearConfig,
  getConfig,
  setConfig,
  type MjlApp,
  type MjlMyAppsConfig,
  type MjlMyAppsVersion,
} from '@mjl/shared';
import { MY_APPS_TAG, registerMyApps } from './mjl-my-apps';

export interface MjlMyAppsInitConfig {
  /** `1` = auto-fetch SSO (default). `2` = host inject `apps` (MIS). */
  version?: MjlMyAppsVersion;
  /** Dipakai hanya jika `version === 2`. `[]` = belum ada favorit. */
  apps?: MjlApp[];
  myApps?: MjlMyAppsConfig;
}

export type MjlMyAppsGlobalType = {
  /** Opsional — panel bisa berjalan tanpa init() karena fetch sendiri dari API */
  init: (config?: MjlMyAppsInitConfig) => void;
  destroy: () => void;
  open: (triggerEl?: HTMLElement) => void;
  close: () => void;
};

let el: HTMLElement | null = null;
let initialized = false;

function mount() {
  if (initialized) return;
  registerMyApps();
  el = document.createElement(MY_APPS_TAG);
  document.body.appendChild(el);
  initialized = true;
}

const MjlMyAppsGlobal: MjlMyAppsGlobalType = {
  init(config?: MjlMyAppsInitConfig) {
    if (config) {
      const existing = getConfig();
      setConfig({
        apps: 'apps' in config ? config.apps : existing?.apps,
        myApps: {
          ...existing?.myApps,
          ...config.myApps,
          version: config.version ?? config.myApps?.version ?? existing?.myApps?.version,
        },
        spotlight: existing?.spotlight,
      });
    }
    mount();
  },

  destroy() {
    el?.remove();
    el = null;
    clearConfig();
    initialized = false;
  },

  open(triggerElement?: HTMLElement) {
    const rect = triggerElement?.getBoundingClientRect();
    bus.emit('my-apps:open', { triggerRect: rect });
  },

  close() {
    bus.emit('my-apps:close');
  },
};

declare global {
  interface Window {
    MjlMyApps?: MjlMyAppsGlobalType;
  }
}

if (typeof window !== 'undefined') {
  window.MjlMyApps = MjlMyAppsGlobal;

  // Auto-mount: panel siap tanpa host perlu memanggil init()
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount, { once: true });
  } else {
    mount();
  }
}

// IIFE CDN: Vite assigns default export → window.MjlMyApps
export default MjlMyAppsGlobal;
